import VueI18n from 'vue-i18n'
import { FASTORDER_MY } from '@/constants';
import Vue from 'vue'
Vue.use(VueI18n);


const messages = {
    EN: {
        translate: {
            //shopping_cart
            your_order: 'Your Order',
            food_cart: 'Item(s) Cart',
            reset_all: 'reset all',
            place_order: 'PLACE ORDER',
            your_cart:' Your Cart',
            start_adding: 'Start adding item(s) to your cart',
            cart_empty: 'Your cart is empty',
            //stock_quantity: 'Stock Quantity',
            confirm_update: 'Confirm & Update',

            //top_Navbar
            setting:'SETTINGS',
            language: 'Language',
            edit_your_profile: 'Edit Your Profile',
            name: 'Name',
            no_phone: 'No Phone',
            email: 'Email',
            save: 'Save',

            //footer
            checkout: 'CHECKOUT',

            // view/index/
            testpage_notice:'TestPage Notice',
            stock_quantity: 'Stock Quantity',
            confirm: 'CONFIRM',

            // goodAttr
            back: 'Back',
            base_price: 'Base price',
            required: 'required',
            optional: 'optional',
            special_instruction:'Special instructions',
            preference: 'Any specific preferences? Let us know',
            no_mayo: 'e.g No Mayo',

            //goodsItem
            no_record:'There is not one record in here.',
            sold_out: 'Sold out',

            // goods
            product_name: 'ProductName',
            summary: 'summary',
            quantity: 'Quantity',
            // confirm: 'CONFIRM', 
            select: 'select',

            //NavUser
            login_register: 'Login / Register',
            order_history: 'Order History',
            logout: 'Logout',
            profile:'Profile',

            //StoreInfo
            table_room: 'TABLES / ROOM',
            order_no: 'ORDER No .',
            // Summary
            confirmation: 'Confirmation',
            estimated_time_arrival: 'Estimated Time Arrival',
            estimated_time_ready: 'Estimated Time Ready',
            schedule: 'SCHEDULE',
            instant: 'INSTANT',
            //TablesInfo
            table_number:'Table Number',
            call_attendant: 'Call Attendant',
            //view/activity/index
            there_is_no_order: 'There is no order on this page',
            created: 'Created',
            receipt: 'Receipt',
            order: 'Order',
            payment_method: 'Payment Method',
            status: 'Status',
            item: 'Item',
            price: 'Price',
            t_point: 'T.Point',
            subtotal: 'Subtotal',
            delivery: 'Delivery',
            total: 'Total',
            //view//cart/takeaway
            clean: 'Clean',
            okay: 'Okey',
            //price: 'Price'
            //name: 'Name',
            mobile_no: 'Mobile No.',
            // email: 'Email',
            address_line_1: 'Address Line 1',
            address_line_2: 'Address Line 2',
            address_line_3: 'Address Line 3',
            pick_up_time: 'Pick Up Time',
            by_placing_this_order: `By placing this order, I agree to the ${FASTORDER_MY}`,
            terms_condition: 'Terms & Condition',
            and: 'and',
            privacy_policy: 'Privacy Policy',
            confirm_small_letter: 'Confirm',
            are_confirm_mobile_phone: 'Are you confirm your mobile phone number',
            you_will_receive_sms: 'You will receive sms for order status update and verification purpose.',
            no_change_it: 'No, change it',  
            // view/index/coupon
            get_coupon_name: 'Get Coupon Name with your phone',
            submit:'Submit',
            // view/index/indexCart
            save_off: 'save off',
            update_basket: 'Update Basket',
            // view/index/indexProduct
            //confirm: 'CONFIRM'
            //view/index/myStore
            merchant_info: 'Merchant Info',
            company: 'Company',
            tel: 'TEL',
            e_mail: 'Email',
            address: 'Address',
            refund_policy: 'Refund Policy',
            announcement: 'Announcement',
            // view/index/vuexdemo
            // clean: 'Bersihkan',
            no_item_in_cart: 'There is not a item on your cart.',
            // subtotal: 'Subtotal',
            add_qty: 'add qty',
            del_qty: 'del qty',
            // view/order/deliveryOrderProcessing
            order_processing: 'Order Processing',
            // view/order/history
            this_order_not_exist: "This order doesn't exist",
            // order_no: 'Order No',
            date_time: 'Date Time',
            dine_in: '[Dine In]',
            contact_info: 'Contact Info',
            table_no: 'Table No',
            // quantity:'Quantity',
            total_amount: 'Total Amount',
            unconfirm: 'Unconfirm',
            confirmed: 'Confirmed',
            completed: 'Completed',
            cancelled: 'Cancelled',
            // address detail
            notes: "Note: Please place order in advance/earlier to avoid delay due to bad weather condition & unexpected traffic jam."



        },
    },
    中文: {
        translate: {
            your_order: '您的订单',
            food_cart: '食物车',
            reset_all: '重置全部',
            place_order: '下订单',
            your_cart:'您的购物车',
            start_adding: '开始将商品添加到购物车',
            cart_empty: '您的购物车是空的',
            //stock_quantity: '库存数量',
            confirm_update: '确认并更新',

            //top_Navbar
            setting:'设定',
            language: '语',
            edit_your_profile: '编辑您的个人资料',
            name: '名称',
            no_phone: '电话号码',
            email: '电子邮件',
            save: '保存',

            //footer
            checkout: '查看',

            // view/index/
            testpage_notice:'测试页通知',
            stock_quantity: '库存数量',
            confirm: '确认',

            // goodAttr
            back: '后退',
            base_price: '基本价格',
            required: '必需的',
            optional: '可选的',
            special_instruction:'特别说明',
            preference: '有什么特别的喜好吗？让我们知道',
            no_mayo: '例子. 全部的 蛋黄酱',

            //goodsItem
            no_record:'这里没有任何记录。',
            sold_out: '卖光了。',

            // goods
            product_name: '产品名称',
            summary: '概括',
            quantity: '数量',
            // confirm: 'CONFIRM', 
            select: '选择',

            //NavUser
            login_register: '登录/注册',
            order_history: '订单历史',
            logout: '登出',
            profile:'轮廓',

            //StoreInfo
            table_room: '桌子/房间',
            order_no: '订单号 。',

            // Summary
            confirmation: '确认',
            estimated_time_arrival: '预计到达时间',
            estimated_time_ready: '预计准备时间',
            schedule: '日程',
            instant: '立即的',

            //TablesInfo
            table_number:'表号',
            call_attendant: '呼叫服务员',

            //view/activity/index
            there_is_no_order: '此页面上没有订单',
            created: '已建立',
            receipt: '收据',
            order: '命令',
            payment_method: '付款方法',
            status: '地位',
            item: '物品',
            price: '价格',
            t_point: 'T.Point',
            subtotal: '小计',
            delivery: '交货',
            total: '全部的',

            //view//cart/takeaway
            clean: '干净的',
            okay: '好的',
            //price: 'Price'
            //name: 'Name',
            mobile_no: '手机号码。',
            // email: 'Email',
            address_line_1: '地址第一行',
            address_line_2: '地址行2',
            address_line_3: '地址行3',
            pick_up_time: '接送时间',
            by_placing_this_order: `通过下订单，我同意 ${FASTORDER_MY}`,
            terms_condition: '条款与协议',
            and: '和',
            privacy_policy: '隐私政策',
            confirm_small_letter: '确认',
            are_confirm_mobile_phone: '您确认您的手机号码吗',
            you_will_receive_sms: '您将收到用于订单状态更新和验证的短信',
            no_change_it: '不，改变它',

            //view/index/coupon
            get_coupon_name: '通过手机获取优惠券名称',
            submit:'提交',

            //view/index/indexCart
            save_off: '保存',
            update_basket: '更新篮',

            //view/index/indexProduct
            //confirm: 'CONFIRM'

            //view/index/myStore
            merchant_info: '商家信息',
            company: '公司',
            tel: '电话',
            e_mail: '电子邮件',
            address: '地址',
            refund_policy: '退款政策',
            announcement: '公告',

            //view/index/vuexdemo
            // clean: 'Bersihkan',
            no_item_in_cart: '您的购物车中没有商品',
            // subtotal: 'Subtotal',
            add_qty: '增加数量',
            del_qty: '删除数量',

            // view/order/deliveryOrderProcessing
            order_processing: '订单处理',

            // view/order/history
            this_order_not_exist: "此订单不存在",
            // order_no: 'Order No',
            date_time: '约会时间',
            dine_in: '[在用餐]',
            contact_info: '联系方式',
            table_no: '表号',
            // quantity:'Quantity',
            total_amount: '总金额',
            unconfirm: '取消确认',
            confirmed: '确认的',
            completed: '完全的',
            cancelled: '取消',
            // address detail
            notes: "注意：请提早送货时间 ， 司机会因为天气，塞车以及等等原因会延迟到达时间"




        },
    },
    BM: {
        translate: {
            //shopping cart
            your_order: 'Pesanan Anda',
            food_cart: 'Troli Barang',
            reset_all: 'Tetapkan semula semua',
            place_order: 'PESAN',
            your_cart:' Troli Anda',
            start_adding: 'Mula menambahkan item ke troli anda',
            cart_empty: 'Troli barang anda kosong',
            //stock_quantity: 'Stock Quantity',
            confirm_update: 'Sahkan & Kemas Kini',

            //top_Navbar
            setting:'TETAPAN',
            language: 'Bahasa',
            edit_your_profile: 'Ubah Profil Anda',
            name: 'Nama',
            no_phone: 'No Tel',
            email: 'Emel',
            save: 'Simpan',
            //footer
            checkout: 'Daftar Keluar',
            // view/index/
            testpage_notice:'Notis Halaman Ujian',
            stock_quantity: 'Kuantiti Stok',
            confirm: 'MENGESAHKAN',
            // goodAttr
            back: 'Kembali',
            base_price: 'Harga asas',
            required: 'diperlukan',
            optional: 'pilihan',
            special_instruction:'Arahan khas',
            preference: 'Ada pilihan khusus? Beritahu kami',
            no_mayo: 'Cth jumlah Mayo',
            //goodsItem
            no_record:'Tidak ada satu rekod di sini.',
            sold_out: 'habis dijual.',
            // goods
            product_name: 'Nama Product',
            summary: 'ringkasan',
            quantity: 'Kuantiti',
            // confirm: 'CONFIRM', 
            select: 'pilih',
            //NavUser
            login_register: 'Log Masuk / Daftar',
            order_history: 'Sejarah Pesanan',
            logout: 'Log Keluar',
            profile: 'Profil',

            //StoreInfo
            table_room: 'MEJA / BILIK',
            order_no: 'PESANAN No .',
            // Summary
            confirmation: 'Pengesahan',
            estimated_time_arrival: 'Anggaran Masa Ketibaan',
            estimated_time_ready: 'Anggaran Masa Sedia',
            schedule: 'JADUAL',
            instant: 'SEGERA',
            //TablesInfo
            table_number:'Nombor Meja',
            call_attendant: 'Panggil Pembantu',
            //view/activity/index
            there_is_no_order: 'Tidak ada pesanan di halaman ini',
            created: 'Dicipta',
            receipt: 'resit',
            order: 'Pesanan',
            payment_method: 'Kaedah Pembayaran',
            status: 'Status',
            item: 'Item',
            price: 'Harga',
            t_point: 'T.Point',
            subtotal: 'Jumlah Kecil',
            delivery: 'Penghantaran',
            total: 'Jumlah',
            //view//cart/takeaway
            clean: 'Bersih',
            okay: 'Okay',
            //price: 'Price'
            //name: 'Name',
            mobile_no: 'No telefon bimbit',
            // email: 'Email',
            address_line_1: 'Alamat Baris 1',
            address_line_2: 'Alamat Baris 2',
            address_line_3: 'Alamat Baris 3',
            pick_up_time: 'Masa Pengambilan',
            by_placing_this_order: `Dengan membuat pesanan ini, saya bersetuju dengan ${FASTORDER_MY}`,
            terms_condition: 'Terma dan syarat',
            and: 'dan',
            privacy_policy: 'Dasar Privasi',
            confirm_small_letter: 'Mengesahkan',
            are_confirm_mobile_phone: 'Adakah anda mengesahkan nombor telefon bimbit anda',
            you_will_receive_sms: 'Anda akan menerima sms untuk kemas kini status pesanan dan tujuan pengesahan.',
            no_change_it: 'Tidak, ubah',
            //view/index/coupon
            get_coupon_name: 'Dapatkan Nama Kupon dengan telefon anda',
            submit:'Serah',
            //view/index/indexCart
            save_off: 'jimat',
            update_basket: 'Kemas kini bakul',
            //view/index/indexProduct
            //confirm: 'CONFIRM'
            //view/index/myStore
            merchant_info: 'Maklumat Peniaga',
            company: 'Syarikat',
            tel: 'TEL',
            e_mail: 'Emel',
            address: 'Alamat',
            refund_policy: 'Polisi Pembayaran Balik',
            announcement: 'Pengumuman',
            //view/index/vuexdemo
            // clean: 'Bersihkan',
            no_item_in_cart: 'Tidak ada barang di troli anda.',
            // subtotal: 'Subtotal',
            add_qty: 'tambah kuantiti',
            del_qty: 'padam kuantiti',
            // view/order/deliveryOrderProcessing
            order_processing: 'Pemprosesan Tempahan',
            // view/order/history
            this_order_not_exist: "Pesanan ini tidak wujud",
            // order_no: 'Order No',
            date_time: 'Masa tarikh',
            dine_in: '[Makan Di Rumah]',
            contact_info: 'maklumat hubungan',
            table_no: 'No Meja',
            // quantity:'Quantity',
            total_amount: 'Jumlah keseluruhan',
            unconfirm: 'tidak mengesahkan',
            confirmed: 'Disahkan',
            completed: 'Selesai',
            cancelled: 'Dibatalkan',
            // address detail
            notes: "Nota: Sila buat pesanan lebih awal/lebih awal untuk mengelakkan kelewatan akibat keadaan cuaca buruk & kesesakan lalu lintas yang tidak dijangka."



        }   
    },
    한국: {
        translate: {
            //shopping cart
            your_order: '당신의 주문',
            food_cart: '아이템 카트',
            reset_all: '모두 초기화하다',
            place_order: '주문하기',
            your_cart:'당신의 짐수레',
            start_adding: '카트에 항목 추가 시작',
            cart_empty: '장바구니가 비어 있습니다.',
            //stock_quantity: 'Stock Quantity',
            confirm_update: '확인 및 업데이트',

            //top_Navbar
            setting:'설정',
            language: '언어',
            edit_your_profile: '프로필 편집',
            name: '이름을 짓다',
            no_phone: '전화번호',
            email: '이메일',
            save: '아껴라',
            //footer
            checkout: '체크아웃',
            // view/index/
            testpage_notice:'테스트 페이지 알림',
            stock_quantity: '수량주',
            confirm: '확인하다',
            // goodAttr
            back: '뒤쪽으로',
            base_price: '기준가격',
            required: '필수의',
            optional: '선택적인',
            special_instruction:'특별지시',
            preference: '특별히 선호하는 것이 있습니까? 저희에게 알려 주십시오.',
            no_mayo: '예: 마요노',
            //goodsItem
            no_record:'여기에는 기록이 하나도 없다.',
            sold_out: '팔렸어요',
            // goods
            product_name: '제품 이름',
            summary: '약식',
            quantity: '수량',
            // confirm: 'CONFIRM', 
            select: '엄선하다',
            //NavUser
            login_register: '로그인/등록',
            order_history: '주문 내역',
            logout: '로그아웃',
            profile: '프로파일',

            //StoreInfo
            table_room: '테이블/룸',
            order_no: '주문번호',
            // Summary
            confirmation: '확인',
            estimated_time_arrival: '예상 도착 시간',
            estimated_time_ready: '예상 준비 시간',
            schedule: '스케줄',
            instant: '인스턴트',
            //TablesInfo
            table_number:'테이블 번호',
            call_attendant: '콜 어텐던트',
            //view/activity/index
            there_is_no_order: '이 페이지에 주문이 없습니다.',
            created: '창조했다',
            receipt: '영수증',
            order: '주문',
            payment_method: '결제 방법',
            status: '상태',
            item: '아이템',
            price: '가격',
            t_point: 'T.Point',
            subtotal: '소계',
            delivery: '배달',
            total: '토탈',
            //view//cart/takeaway
            clean: '깨끗하다',
            okay: '그래',
            //price: 'Price'
            //name: 'Name',
            mobile_no: '모바일 번호',
            // email: 'Email',
            address_line_1: '주소 라인 1',
            address_line_2: '주소 라인 2',
            address_line_3: '주소 라인 3',
            pick_up_time: '시간 픽업',
            by_placing_this_order: `이 주문을 함으로써 ${FASTORDER_MY} 에 동의합니다.`,
            terms_condition: '이용약관',
            and: '그리고',
            privacy_policy: '개인 정보 보호 정책',
            confirm_small_letter: '확인하다',
            are_confirm_mobile_phone: '휴대폰 번호를 확인하시겠습니까?',
            you_will_receive_sms: '주문 상태 업데이트 및 확인 목적으로 SMS를 받게됩니다.',
            no_change_it: '아니, 바꿔',
            //view/index/coupon
            get_coupon_name: '휴대폰으로 쿠폰 이름 가져오기',
            submit:'제출하다',
            //view/index/indexCart
            save_off: '을 절약하다.',
            update_basket: '바스켓 업데이트',
            //view/index/indexProduct
            //confirm: 'CONFIRM'
            //view/index/myStore
            merchant_info: '상인 정보',
            company: '컴퍼니',
            tel: '번호 전화',
            e_mail: '이메일',
            address: '주소',
            refund_policy: '환불 정책',
            announcement: '공지사항',
            //view/index/vuexdemo
            // clean: 'Bersihkan',
            no_item_in_cart: '장바구니에 물건이 없습니다.',
            // subtotal: 'Subtotal',
            add_qty: '양을 더하다',
            del_qty: '수량을 삭제하다',
            // view/order/deliveryOrderProcessing
            order_processing: '주문 처리',
            // view/order/history
            this_order_not_exist: "이 주문은 존재하지 않습니다",
            // order_no: 'Order No',
            date_time: '날짜 시간',
            dine_in: '[식사]',
            contact_info: '연락처 정보',
            table_no: '테이블 번호',
            // quantity:'Quantity',
            total_amount: '총액',
            unconfirm: '확인 취소',
            confirmed: '확인됨',
            completed: '완전한',
            cancelled: '취소 된',
            // address detail
            notes: "참고: 악천후 및 예기치 않은 교통 체증으로 인한 지연을 피하기 위해 미리/더 일찍 주문하십시오."




        }   
    }
}

// Create VueI18n instances with options
export default new VueI18n({
    locale: "EN", //set locale
    messages, // set locale message
});